export { disableWarningsSlot } from "./utils.js";
export { maskFragment } from "./maskFragment.js";
export { maskOperation } from "./maskOperation.js";
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@apollo/client/masking/index.js
// module id = 750
// module chunks = 11